module.exports = PotDetailsTemplate = function PotDetailsTemplate(game_mod) {
  var pp = game_mod.game.state.player_pot;
  var pn = game_mod.game.state.player_names;
  var show_stake = typeof game_mod.game.stake == "string";
  var html = "<div class=\"pot-details-overlay".concat(show_stake ? " crypto-stake" : "", "\">");
  for (var i = 0; i < pp.length; i++) {
    html += "<div class=\"saito-table-row\">\n\t\t\t\t\t<div class=\"player-name\">".concat(pn[i], "</div>\n\t\t\t\t\t<div class=\"player-role\">").concat(game_mod.returnPlayerRole(i + 1), "</div>\n\t\t\t\t\t<div class=\"player-bet\">").concat(pp[i], "</div>");
    if (show_stake) {
      html += "<div class=\"player-bet\">".concat(game_mod.convertChipsToCrypto(pp[i]), " ").concat(game_mod.game.crypto, "</div>");
    }
    html += "</div>";
  }
  html += "</div>";
  return html;
};